import { REQUEST_BODY_COMPOSITION_INDEX_SYMBOL as e } from "./request-body-composition-index.js";
import { partitionAllOfCompositions as t } from "./helpers/partition-all-of-compositions.js";
import { getCycleKey as n } from "./helpers/schema-cycle.js";
import { useLocalization as r } from "./localization/index.js";
import { getDiscriminatorValues as i } from "./helpers/get-discriminator-values.js";
import { getSchemaType as a } from "./helpers/get-schema-type.js";
import { getModelNameWithArray as o } from "./helpers/schema-name.js";
import s from "./SchemaGlyphPuck.vue.js";
import c from "./SchemaRailPanel.vue.js";
import l from "./Schema.vue.js";
import { Fragment as u, computed as d, createBlock as f, createCommentVNode as p, createElementBlock as m, createElementVNode as h, createTextVNode as g, createVNode as _, defineComponent as v, inject as y, normalizeClass as b, openBlock as x, ref as S, renderList as C, resolveComponent as w, toDisplayString as T, unref as E, watch as D, withCtx as O } from "vue";
import { ScalarIconCaretUpDown as k } from "@scalar/icons";
import { ScalarListbox as A } from "@scalar/components/listbox";
import { resolve as j } from "@scalar/workspace-store/resolve";
import { isDefined as M } from "@scalar/helpers/array/is-defined";
//#region src/schema/SchemaComposition.vue?vue&type=script&setup=true&lang.ts
var N = { class: "property-rule [.children+&]:mt-1.5!" }, P = {
	class: "composition-selector composition-selector--tree group/tree-control font-code relative flex w-fit max-w-full cursor-pointer items-start gap-1.5 py-1 text-sm",
	type: "button"
}, F = { class: "text-c-1 shrink-0 [font-weight:var(--scalar-bold)] whitespace-nowrap" }, I = ["title"], L = {
	key: 0,
	class: "text-red"
}, R = /*@__PURE__*/ v({
	__name: "SchemaComposition",
	props: {
		composition: {},
		discriminator: {},
		name: {},
		schema: {},
		level: {},
		depth: { default: 0 },
		compact: {
			type: Boolean,
			default: !1
		},
		hideHeading: {
			type: Boolean,
			default: !1
		},
		hideModelNames: { type: Boolean },
		breadcrumb: {},
		eventBus: {},
		options: {},
		schemaContext: {},
		compositionPath: {},
		scrollTargetId: {},
		specificationExtension: {},
		expansion: {}
	},
	setup(v) {
		let R = v, { translate: z } = r(), B = d(() => R.composition === "allOf" ? t(R.schema).segments : []), V = d(() => [R.schema[R.composition]].flat().map((e) => ({
			value: j.schema(e),
			original: e
		})).filter((e) => M(e.value))), H = d(() => V.value.map((e, t) => {
			let n = j.schema(e.original), r = (o(n)?.label ?? a(n)) || z("schema.schema"), s = (R.schema.discriminator ?? R.discriminator)?.mapping, c = i(n.$ref, s);
			return {
				id: String(t),
				label: c.length ? `${c.join(", ")} · ${r}` : r
			};
		})), U = d(() => R.compositionPath?.length ? [...R.compositionPath, R.composition].join(".") : ""), W = y(e, void 0), G = d(() => {
			if (R.schemaContext !== "requestBody" || !W?.value || !U.value) return 0;
			let e = W.value[U.value];
			return typeof e != "number" || Number.isNaN(e) ? 0 : Math.max(0, Math.min(e, H.value.length - 1));
		}), K = S();
		D([H, G], ([e, t]) => {
			(!K.value || !e.some((e) => e.id === K.value?.id)) && (K.value = e[t] ?? e[0]);
		}, { immediate: !0 });
		let q = (e) => z(`schema.${e}`), J = d(() => V.value[Number(K.value?.id ?? "0")]?.value), Y = d(() => R.schemaContext === "requestBody" && R.compositionPath?.length === 1), X = d(() => n(V.value[Number(K.value?.id ?? "0")]?.original)), Z = S(!!R.options.expandAllSchemaProperties);
		return W && R.schemaContext === "requestBody" && U.value && D(K, (e) => {
			let t = e ? Number(e.id) : 0;
			Number.isNaN(t) || (W.value = {
				...W.value,
				[U.value]: t
			});
		}, { immediate: !0 }), (e, t) => {
			let n = w("SchemaComposition", !0);
			return x(), m("div", N, [R.composition === "allOf" ? (x(!0), m(u, { key: 0 }, C(B.value, (e, t) => (x(), m(u, { key: t }, [e.kind === "object" ? (x(), f(l, {
				key: 0,
				breadcrumb: v.breadcrumb,
				compact: v.compact,
				compositionPath: v.compositionPath,
				depth: v.depth,
				discriminator: v.discriminator,
				eventBus: v.eventBus,
				expansion: v.expansion,
				hideDescription: Y.value,
				hideHeading: v.hideHeading,
				hideModelNames: v.hideModelNames,
				level: v.level + 1,
				name: v.name,
				noncollapsible: !0,
				options: v.options,
				schema: e.schema,
				schemaContext: v.schemaContext,
				scrollTargetId: v.scrollTargetId,
				specificationExtension: v.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"depth",
				"discriminator",
				"eventBus",
				"expansion",
				"hideDescription",
				"hideHeading",
				"hideModelNames",
				"level",
				"name",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			])) : (x(), f(n, {
				key: 1,
				breadcrumb: v.breadcrumb,
				compact: v.compact,
				composition: e.composition,
				compositionPath: [...v.compositionPath ?? [], String(e.choiceIndex)],
				depth: v.depth,
				eventBus: v.eventBus,
				expansion: v.expansion,
				hideHeading: v.hideHeading,
				hideModelNames: v.hideModelNames,
				level: v.level,
				options: v.options,
				schema: e.value,
				schemaContext: v.schemaContext,
				scrollTargetId: v.scrollTargetId,
				specificationExtension: v.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"composition",
				"compositionPath",
				"depth",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			]))], 64))), 128)) : (x(), f(c, {
				key: 1,
				class: "composition-panel composition-panel--tree mt-1 mb-0.5",
				depth: v.depth + 1
			}, {
				default: O(() => [_(E(A), {
					modelValue: K.value,
					"onUpdate:modelValue": t[0] ||= (e) => K.value = e,
					class: "w-fit max-w-full min-w-40",
					options: H.value
				}, {
					default: O(() => [h("button", P, [
						_(s, {
							anchor: "line",
							class: "composition-selector-icon mt-1"
						}, {
							default: O(() => [_(E(k))]),
							_: 1
						}),
						h("span", F, T(q(R.composition)), 1),
						t[2] ||= h("span", {
							"aria-hidden": "true",
							class: "text-c-3 shrink-0"
						}, "·", -1),
						h("span", {
							class: b(["composition-selector-label text-c-1 min-w-0 truncate [font-weight:var(--scalar-bold)]", { "line-through": J.value?.deprecated }]),
							title: K.value?.label || E(z)("schema.schema")
						}, T(K.value?.label || E(z)("schema.schema")), 11, I),
						J.value?.deprecated ? (x(), m("div", L, T(E(z)("schema.deprecated")), 1)) : p("", !0)
					])]),
					_: 1
				}, 8, ["modelValue", "options"]), !Z.value && v.level > 2 ? (x(), m("button", {
					key: 0,
					class: "composition-details-toggle group/tree-control font-code text-c-1 relative flex w-fit cursor-pointer items-center py-1.5 text-sm font-normal",
					type: "button",
					onClick: t[1] ||= (e) => Z.value = !0
				}, [_(s), g(" " + T(E(z)("schema.showSchemaDetails")), 1)])) : (x(), f(l, {
					key: K.value?.id ?? "0",
					breadcrumb: v.breadcrumb,
					compact: v.compact,
					compositionPath: v.compositionPath,
					cycleKey: X.value,
					depth: v.depth + 1,
					discriminator: v.discriminator,
					eventBus: v.eventBus,
					expansion: v.expansion,
					hideHeading: v.hideHeading,
					hideModelNames: v.hideModelNames,
					level: v.level + 1,
					name: v.name,
					noncollapsible: !0,
					options: v.options,
					schema: J.value,
					schemaContext: v.schemaContext,
					scrollTargetId: v.scrollTargetId,
					specificationExtension: v.specificationExtension
				}, null, 8, [
					"breadcrumb",
					"compact",
					"compositionPath",
					"cycleKey",
					"depth",
					"discriminator",
					"eventBus",
					"expansion",
					"hideHeading",
					"hideModelNames",
					"level",
					"name",
					"options",
					"schema",
					"schemaContext",
					"scrollTargetId",
					"specificationExtension"
				]))]),
				_: 1
			}, 8, ["depth"]))]);
		};
	}
});
//#endregion
export { R as default };

//# sourceMappingURL=SchemaComposition.vue.script.js.map